import { Component, HostListener, OnInit, Renderer2, ViewChild, Input, ViewEncapsulation, OnDestroy } from '@angular/core';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { environment } from 'src/environments/environment';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TenderService } from '../../_services/tender.service';
import { GlobalLoaderService } from 'src/app/modules/shared/_services/global-loader.service';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AlertMessageService } from './../../../shared/_services/alert-message.service';
import { PARAMS } from 'src/app/_configs/params';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { StripMarginService } from 'src/app/modules/shared/_services/strip-margin.service';
import { HomePageMetaService } from './../../_services/homepage-meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ThankyouModalComponent } from 'src/app/modules/shared/_components/thankyou-modal/thankyou-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tenders',
  templateUrl: './tenders.component.html',
  styleUrls: ['./tenders.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('toggle', [
      state('visible', style({
        opacity: 1,
        height: '*'
      })),
      state('hidden', style({
        opacity: 0,
        height: '0px'
      })),
      transition('visible <=> hidden', [
        animate('0.7s ease-in-out')
      ])
    ])
  ]
})
export class TendersComponent implements OnInit, OnDestroy {
  imageBasePath: string = environment.TENDER.IMAGE_BASE_URL;
  @ViewChild(ThankyouModalComponent) Thankyoumodal!: ThankyouModalComponent;

  @Input() isLeadFormVisible: boolean = false;
  @Input() tenderData: any;
  isBrowser: boolean = false;

  @HostListener('window:scroll', ['$event']) onScroll(event: any) {
    this.sharedService.homepageNavigationFixedOnMobileView();
  }

  type: string = "";
  slideConfig2: any;
  baseUrl: any = environment.TENDER.BASE_URL;
  showInputs: boolean = false; numberOfItems: number = 1;
  isScroll: boolean = true;
  containerId: string = "slider-" + Math.random().toString(36).substr(2, 9);
  hideContainer = false;
  topPerformingContainer = 'top-performing-inner-container';
  isLeftVisible: boolean = false;
  isRightVisible: boolean = true;
  blogList: any;
  counts: any;

  leadForm!: FormGroup;
  isLoggedIn: boolean = false;
  private userSubscription!: Subscription;
  userDetails: any;
  isMobile: boolean = true;
  isWebView: boolean = false;
  stripMargin: boolean = true;
  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    this.filterVisibleoOnMobile();
  }
  shouldShowTrialBanner = false;
  constructor(private homemetaService: HomePageMetaService, private route: ActivatedRoute,
    private router: Router, private sharedService: SharedService, private renderer2: Renderer2, private tenderService: TenderService,
    private globalLoaderService: GlobalLoaderService,
    private alertMessageService: AlertMessageService, private authService: AuthService, private fb: FormBuilder,
    private stripMarginService: StripMarginService
  ) {
    this.isBrowser = this.sharedService.isBrowser;
    this.setClassOnHompage();
    this.initializeForm();
    this.retrieveTenderStats();
    this.isWebView = this.checkIfWebView();
    this.filterVisibleoOnMobile();
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      const token = params['token'];
      const plan = params['plan'];
      if (id && token && plan) {
        this.captureInterest(id, token, plan);
      }
    });


    this.stripMarginService.stripMargin$.subscribe(
      (value) => {
        this.stripMargin = value;
      }
    );

    const pageSize = '12';
    if (this.sharedService.isBrowser) {
      this.sharedService.getBlogList(pageSize, '1', '').subscribe((res: any) => {
        this.blogList = res?.data?.blogDataList;
      });
    }
    this.checkUserLoggedIn();
    this.homemetaService.setMetas();
    // this.checkTrialBanner();
    this.userSubscription = this.authService.user$.subscribe(() => {
      this.checkTrialBanner();
    });

  }
  async checkTrialBanner() {
    const { show } = await this.authService.shouldShowTrialBanner();
    this.shouldShowTrialBanner = show;
  }

  captureInterest(id: string, token: string, plan: string): void {
    this.sharedService.interestPlan(id, token, plan).subscribe(
      (response) => {
        this.Thankyoumodal.isThankyouVisible = true;
      },
      (error) => {
        console.error('API Error:', error);
        this.Thankyoumodal.isThankyouVisible = true;
      }
    );
  }


  checkIfWebView(): boolean {
    if (typeof window === 'undefined') {
      return false;
    }
    const userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.includes('wv') || userAgent.includes('webview');
  }

  filterVisibleoOnMobile() {
    if (this.sharedService.isBrowser) {
      if (window.outerWidth < PARAMS.STATIC_PARAMS.WINDOWS_OUTER_WIDTH) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  }

  checkUserLoggedIn() {
  this.userSubscription = this.authService.user$.subscribe(user => {
      this.isLoggedIn = !!user;
      this.userDetails = user?.userData || null;
      if (this.isLoggedIn && this.userDetails) {
        this.autoPopulateForm();
      }
    });
    // this.isLoggedIn = this.authService.isLoggedIn();
    // if (this.isLoggedIn) {
    //   const user = this.authService.getDecryptedUser();
    //   if (user) {
    //     this.userDetails = user.userData;
    //     this.autoPopulateForm();
    //   }
    // }
  }

  autoPopulateForm() {
    if (this.userDetails) {
      this.leadForm.patchValue({
        businessName: this.userDetails.businessName || '',
        phone: this.userDetails.phone || '',
        gstNum: this.userDetails.gstNum || '',
        name: this.userDetails.name || '',
        updatesOnWhatsapp: this.userDetails.updatesOnWhatsapp || false
      });
    }
  }

  private initializeForm(): void {
    this.leadForm = this.fb.group({
      businessName: ['', [Validators.required, Validators.maxLength(100), this.noNumbersValidator]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[0-9]{10}$/),
          Validators.pattern(PARAMS.REGEX.INDIAN_MOBILE_NUMBER_VALIDATOR_REGEX)
        ]
      ],
      gstNum: ['', [Validators.required, Validators.maxLength(15)]],
      name: ['', [Validators.maxLength(100), this.noNumbersValidator]],
      updatesOnWhatsapp: [false]
    });
  }

  private noNumbersValidator(control: FormControl): { [key: string]: boolean } | null {
    const hasNumber = /\d/.test(control.value);
    return hasNumber ? { 'noNumbers': true } : null;
  }

  onSubmit(): void {
    if (this.leadForm.invalid) {
      return;
    }
    this.globalLoaderService.setLoaderState(true);

    this.sharedService.userinterest(this.leadForm.value).subscribe({
      next: (res: any) => {
        // Call subscribeTenders with the response from userinterest
        this.globalLoaderService.setLoaderState(false);
        this.alertMessageService.addSuccess('We have received your request and will get back to you shortly').show();
        this.leadForm.reset();
        this.isLeadFormVisible = false;
      },
      error: (err: any) => {
        console.error('Error submitting form:', err);
        this.globalLoaderService.setLoaderState(false);
        this.alertMessageService.addError(err.error?.message || 'An error occurred. Please try again later.').show();
      },
      complete: () => {
        this.globalLoaderService.setLoaderState(false);
      }
    });
  }

  retrieveTenderStats() {
    this.tenderService.tenderStats().subscribe((res: any) => {
      this.counts = res?.data;
    });
  }

  showAllInputs() {
    this.showInputs = true;
  }

  onDivClick(event: MouseEvent) {
    event.stopPropagation();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.showInputs = false;
  }

  setClassOnHompage() {
    if (this.sharedService.isBrowser) {
      this.renderer2.addClass(document.body, 'homepage');
    }
  }

  clickToNavigate(url: string) {
    this.router.navigateByUrl(url);
  }

  ngOnDestroy() {
    if (this.sharedService.isBrowser) {
      this.renderer2.removeClass(document.body, 'homepage');
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
  }

  onSliderScroll(event: Event) {
    const data = this.sharedService.onScroll(event);
    this.isRightVisible = data?.isRightVisible;
    this.isLeftVisible = data?.isLeftVisible
  }

  scrollSliderDiv(right?: any) {
    this.sharedService.scrollDiv(this.containerId, this.numberOfItems, right);
  }
}
